import classNames from 'classnames/bind';
import styles from './StudentActivity.module.css';
import { STUDENT_EBOOK_ACTIVITY_SUFFIX } from '../../../../constants';
import { useLocation } from 'react-router-dom';
import { analysisApiSlice } from '../../../../services/analysis';
import { useEffect, useState } from 'react';
import { Project } from '../../../../types/analysis';
import { useAppDispatch, useAppSelector } from '../../../../hooks/useRedux';
import { selectProjectStudentList } from '../../../../features/analysisSlice';
import AliasHeading from '../../AliasHeading';
import LearningActivity from '../../LearningActivity';

export default function StudentActivity() {
  const cx = classNames.bind(styles);
  const dispatch = useAppDispatch();
  const {
    state: { projectId, userId },
  } = useLocation();
  const studentList = useAppSelector(selectProjectStudentList);
  const [slideIndex, setSlideIndex] = useState(0);
  const [projectData, setProjectData] = useState<Project>();
  const [getProject] = analysisApiSlice.useLazyGetClassProjectQuery();

  const getProjectData = async () => {
    try {
      const { data } = await getProject({
        projectId,
        userId: studentList[slideIndex].userId,
      });
      setProjectData(data);
    } catch (error) {
      console.error('Fail to get project', error);
    }
  };

  useEffect(() => {
    try {
      getProjectData();
    } catch (error) {
      console.error('Failed to get class project', error);
    }

    const idx = studentList.findIndex((student) => student.userId === userId);
    setSlideIndex(idx);
  }, [projectId, userId]);

  if (!projectData) return null;

  const { title } = projectData;

  return (
    <>
      <AliasHeading
        alias={studentList[slideIndex].nm}
        suffix={STUDENT_EBOOK_ACTIVITY_SUFFIX}
        hasBackButton={true}
        title={title}
      />

      <div className={cx('dash_section', 'p40')}>
        <div className={cx('inner')}>
          <div className={cx('info_panel', 'type_graph')}>
            <LearningActivity
              projectId={projectId}
              userId={userId}
              tabIdx={2}
            />
          </div>
        </div>
      </div>
    </>
  );
}
